var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190.92 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#c69749;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 151.13,
    y1: 189.13,
    x2: 151.13,
    y2: 115.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 192)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dab46e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 95.37,
    y1: 192,
    x2: 95.37,
    y2: 182.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 190.92,
    y1: 98.55,
    x2: 181.19,
    y2: 98.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 95.7,
    y1: 142.51,
    x2: 95.7,
    y2: 50.48,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-check-congrats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.36,3a4.78,4.78,0,0,0-2.47,9.24A86.2,86.2,0,0,1,178.52,73.2a4.77,4.77,0,0,0,4.6,3.55,4.85,4.85,0,0,0,1.24-.16,4.79,4.79,0,0,0,3.36-5.87A95.76,95.76,0,0,0,120.36,3Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.32,9.57c1.19,0,2.39.11,3.58.19l.36,0A4.79,4.79,0,0,0,97.6.22C96.29.12,95,.05,93.65,0a4.79,4.79,0,0,0-.33,9.57Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.51,178.72A86.22,86.22,0,0,1,12.88,117.8a4.76,4.76,0,1,0-9.2,2.48A95.78,95.78,0,0,0,71.05,188a4.76,4.76,0,0,0,5.83-3.39A4.79,4.79,0,0,0,73.51,178.72Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.23,169.93a85.64,85.64,0,0,1-85.75,0,4.74,4.74,0,0,0-6.5,1.75,4.79,4.79,0,0,0,1.74,6.54,95.17,95.17,0,0,0,95.27,0,5,5,0,0,0,1-.77,4.78,4.78,0,0,0-5.75-7.52Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.73,120.28a4.77,4.77,0,1,0-9.21-2.48,86.18,86.18,0,0,1-60.63,60.92,4.78,4.78,0,0,0-3.53,4.62,4.87,4.87,0,0,0,.17,1.24,4.75,4.75,0,0,0,5.83,3.38A95.79,95.79,0,0,0,187.73,120.28Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.22,73A86.2,86.2,0,0,1,72.85,12a4.79,4.79,0,0,0-2.46-9.25A95.76,95.76,0,0,0,3,70.48a4.85,4.85,0,0,0-.16,1.24A4.76,4.76,0,0,0,12.22,73Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21,138a86.8,86.8,0,0,1,0-86.16,4.77,4.77,0,1,0-8.25-4.78,96.4,96.4,0,0,0,0,95.72,5.07,5.07,0,0,0,.76,1A4.77,4.77,0,0,0,21,138Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.39,91.39c0,1.2-.1,2.4-.19,3.59,0,.13,0,.25,0,.36a4.76,4.76,0,0,0,9.51.35c.1-1.31.17-2.65.22-4a4.77,4.77,0,1,0-9.53-.33Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.39,49.49A15.32,15.32,0,0,0,126.45,54L76.75,104,65,92.12a15.48,15.48,0,0,0-26.42,11,15.48,15.48,0,0,0,4.53,11L65.84,137l.2.19a.47.47,0,0,0,.1.1l.2.19.09.08.21.18a.27.27,0,0,0,.08.07l.21.18.08.07.21.17.11.09.22.16.1.08.22.15.09.06.22.15.1.07.22.14.11.07.22.13.12.07.23.13.09.05.23.13.1,0,.23.12.12.06.24.11.1,0,.24.11.11,0,.24.1.1,0,.24.09.11,0,.25.09.12,0,.25.08.1,0,.25.07.12,0,.25.07.08,0,.24.06.16,0,.25.06h.08l.25.06.14,0,.14,0,.23,0,.26,0h.09l.25,0H75l.25,0h.09l.26,0h2.35l.26,0h.1l.25,0h.13l.26,0H79l.25,0,.24,0,.14,0,.13,0,.25-.05.11,0,.25,0,.11,0,.25-.07.1,0,.25-.07.12,0,.25-.08.1,0,.25-.08.12,0,.24-.09.1,0,.24-.09.14-.06.24-.1.06,0,.24-.11.14-.06.24-.11.09-.05.24-.12.11-.06.23-.12.09-.06.23-.13.12-.07.22-.13.11-.07.23-.15.07,0,.23-.15.09-.07.22-.15.11-.08.22-.16.1-.09.22-.17.06-.06.21-.17.18-.15.13-.12.07-.07.2-.18.11-.1.2-.2.11-.11L148.34,76a15.55,15.55,0,0,0-11-26.55Zm4.22,19.78-60.67,61-.34.31-.81.58-.92.44-1.15.3-1,.08h-.14l-1-.11-1-.28-1-.51-.84-.63-23-23.06a6,6,0,0,1,0-8.46,6,6,0,0,1,8.43,0l15.16,15.23a4.74,4.74,0,0,0,6.73,0L133.18,60.8a6,6,0,0,1,8.43,8.47Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCongrats);
export default __webpack_public_path__ + "static/media/icon-check-congrats.fd07044817b8c6c02a12dd426b862752.svg";
export { ForwardRef as ReactComponent };